<template>
  <span
    class="cstm-status-badge"
    style="background: rgba(var(--vs-primary), 1); color: #fff"
  >
    <b>{{ params.data.final_marks ? params.data.final_marks : 'N/A' }}</b>
  </span>
</template>

<script>
export default {
  name: 'TotalMarksCell'
}
</script>